import * as types from './actionTypes';

export function setDrawerOpenFlag(isDrawerActive) {
  return {
    type: types.SET_DRAWER_OPEN_FLAG,
    isDrawerActive,
  };
}

export function setSearchOpenFlag(isSearchActive) {
  return {
    type: types.SET_SEARCH_OPEN_FLAG,
    isSearchActive,
  };
}

export function setActiveStageIndicatorSettingsOpenFlag(isActiveStageIndicatorSettingsEnabled) {
  return {
    type: types.SET_ACTIVE_STAGE_INDICATOR_SETTINGS_OPEN_FLAG,
    isActiveStageIndicatorSettingsEnabled,
  };
}
